import { render, staticRenderFns } from "./mc-meal-card.vue?vue&type=template&id=c998386a"
import script from "./mc-meal-card.vue?vue&type=script&lang=ts"
export * from "./mc-meal-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports